module.exports = __webpack_public_path__ + "static/media/SS4.aa090036.png";